import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "sPlant_Temp_Quotation_Process_Detail"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

let fields = {
  default: [
    { key: 'id', label: "编号" },
    { key: 'ParentId', label: "父id" },
    { key: 'ItemId', label: "物料id" },
    { key: 'QuotationId', label: "临时报价id" },
    { key: 'Quotation_Item_Detail_Id', label: "临时报价物料详情id" },
    { key: 'ProcessName', label: "工序名称（包含物料/部件名称）" },
    { key: 'ProcessResourceId', label: "工序资源id" },
    { key: 'ResourceName', label: '资源名称' },
    { key: 'ProcessCount', label: '工序次数' },
    { key: 'StandardManpower', label: '标准人力' },
    { key: 'StandardWorkingHours', label: '标准工时' },
    { key: 'Kilowatt', label: '功率' },
    { key: 'TimeSetting', label: '设置时间' },
    { key: 'ProductionCapacity', label: '产能' },
    { key: 'GoodProductRate', label: '良率' },
    { key: 'MouldCount', label: '模数' },
    { key: 'RunningParameters', label: '变化参数' },
    { key: 'SortNo', label: '排序' },
    { key: 'Description', label: '描述' },
  ]
}

const dataForm = {}

const validatePositive = (rule, value, callback) => {
  if (!value && value != 0) { // 空值（未填写）
    callback(new Error('请输入数值'))
  }
  if (typeof value !== 'number') {
    callback(new Error('请输入有效数字！'))
  }
  if (value < 0) { // 小于0
    callback(new Error('必须大于等于0！'))
  }
  else
    callback()
}
///前端验证
const rules = {
  ProcessResourceId: [
    { required: true, message: '请填选择工序', trigger: 'change' }
  ],
  ProcessName: [
    { required: true, message: '请填选择工序', trigger: 'change' }
  ],
  ResourceName: [
    { required: true, message: '请填选择资源', trigger: 'change' }
  ],
  ProcessCount: [
    { required: true, validator: validatePositive, trigger: 'blur' }
  ],
  StandardManpower: [
    { required: true, validator: validatePositive, trigger: 'blur' }
  ],
  StandardWorkingHours: [
    { required: true, validator: validatePositive, trigger: 'blur' }
  ],
  Kilowatt: [
    { required: true, validator: validatePositive, trigger: 'blur' }
  ],
  TimeSetting: [
    { required: true, validator: validatePositive, trigger: 'blur' }
  ],
  ProductionCapacity: [
    { required: true, validator: validatePositive, trigger: 'blur' }
  ],
  GoodProductRate: [
    { required: true, validator: validatePositive, trigger: 'blur' }
  ],
  MouldCount: [
    { required: true, validator: validatePositive, trigger: 'blur' }
  ],
  RunningParameters: [
    { required: true, validator: validatePositive, trigger: 'blur' }
  ],
  SortNo: [
    { required: true, message: '请输入排序编号', trigger: 'blur' }
  ],
}

const methods = {
  ///get
  async getData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async checkSortNo(params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "check_progress_sortNo", {}, {})
    let _fields = ['isExsit']
    let result = await item_biz_data.execAction({
      params: params,
      fields: _fields
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveData(params) {
    let _actions = []
    for (var k in params) {
      if (k == "add") {
        delete params[k].id
        _actions.push(
          biz_data.insertAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "edit") {
        _actions.push(
          biz_data.updateAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "delete") {
        _actions.push(
          biz_data.removeAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data[0]
    } else {
      return null
    }
  }
}
export { biz_data, dataForm, fields, methods, rules };

